module.exports = __webpack_public_path__ + "static/media/ic_service_layout_default.1ecc8a4e.svg";